<template>
    <div class="featured_content_container">
        
        <b-row class="align_left"> 
            <b-col cols="12" v-for="(block,index) in content" :key="index">
                <div class="item_extra_container" v-if="block.type==='text'" v-html="block.content">
                </div>
                <div class="item_extra_container" v-if="block.type==='button'">
                    <p :style="{textAlign : block.alignement}"><a :href="block.url" target="_blank" ><b-button class="button_extra_infos" :style="{color : block.color+' !important',backgroundColor : block.background_color+' !important'}">{{block.text}}</b-button></a></p>
                </div>
                <div class="item_extra_container" v-if="block.type==='image'">
                    <p :style="{textAlign : block.alignement}"><img :src="block.url" style="display:inline-block;height:auto;" :style="{width : block.largeur+'% !important'}"/></p>
                </div>
                <div class="item_extra_container" v-if="block.type==='iframe'">
                    <p  class="align_center container-iframe" v-html="block.code"></p>
                </div>
            </b-col>
        </b-row>
    
    </div>
</template>

<script>
    export default {
        props : ["content"],
        data() {
            return {
                
            }
        },
    }
</script>

<style lang="scss">
    .ql-align-center{
        text-align:center;
    }
    .item_extra_container{
        margin-top:15px;
    }

    .container-iframe iframe{
        max-width:100% !important;
        margin:auto;
    }
</style>